/* variant-combo.js (locale-proof)
   - Añade "variant-N-M" a #art-container (N=surface idx, M=frame idx)
   - Añade también "N-M" a #art-container (clase corta)
   - Añade "surface-N" a #art-container y .product
   - Si la combinación no está disponible (según DOM) → fuerza marco a 1 (primer frame disponible)
   - Actualiza <span data-live-frame> con el label del marco seleccionado
   - NO depende de textos ni del JSON de variantes (seguro en multidioma)
*/
(function () {
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  function init() {
    const art = document.getElementById('art-container');
    if (!art) return;

    const product = document.querySelector('.product');
    const slider = document.querySelector('[id^="Slider-Gallery-"]');

    /* --------------------- HELPERS --------------------- */
    function getAllInputs(type) {
      return Array.from(document.querySelectorAll(`input[data-type="${type}"]`));
    }
    function getEnabledInputs(type) {
      return getAllInputs(type).filter(el => !el.disabled && !el.classList.contains('disabled'));
    }
    function getChecked(type) {
      return document.querySelector(`input[data-type="${type}"]:checked`);
    }
    function getIndexAmong(list, el) {
      const i = list.indexOf(el);
      return i >= 0 ? i + 1 : 1;
    }

    /* ------------ surface-N (art + .product) ------------ */
    function cleanSurfaceClasses() {
      art.classList.forEach(c => { if (/^surface-\d+$/.test(c)) art.classList.remove(c); });
      if (product) {
        product.classList.forEach(c => { if (/^surface-\d+$/.test(c)) product.classList.remove(c); });
      }
    }
    function setSurfaceClass(surfaceIndex) {
      cleanSurfaceClasses();
      art.classList.add(`surface-${surfaceIndex}`);
      if (product) product.classList.add(`surface-${surfaceIndex}`);
    }

    /* ----------------- variant-N-M + N-M ----------------- */
    function cleanVariantClasses() {
      art.classList.forEach(c => {
        if (/^variant-\d+-\d+$/.test(c) || /^\d+-\d+$/.test(c)) {
          art.classList.remove(c);
        }
      });
    }
    function setVariantClass(surfaceIndex, frameIndex) {
      cleanVariantClasses();
      // Clase "larga"
      art.classList.add(`variant-${surfaceIndex}-${frameIndex}`);
      // Clase "corta" N-M
      art.classList.add(`${surfaceIndex}-${frameIndex}`);
    }

    /* ----------- ACTUALIZAR TEXTO DEL MARCO ----------- */
    function getSelectedFrameText() {
      const checked = getChecked('frame');
      if (!checked) return '';
      const id = checked.getAttribute('id');
      if (id) {
        const lbl = document.querySelector(`label[for="${CSS.escape(id)}"]`);
        if (lbl) {
          const clone = lbl.cloneNode(true);
          clone.querySelectorAll('.visually-hidden, .label-unavailable, [aria-hidden]').forEach(el => el.remove());
          return clone.textContent.trim();
        }
      }
      return (checked.value || '').trim();
    }
    function updateFrameLabel() {
      const span = document.querySelector('[data-live-frame]');
      if (!span) return;
      const txt = getSelectedFrameText();
      if (txt) span.textContent = txt;
    }

    /* ------------------ LÓGICA PRINCIPAL ------------------ */
    function ensureValidOrAdjust() {
      const surfaceAll = getAllInputs('surface');
      const frameAll   = getAllInputs('frame');

      const surfaceChecked = getChecked('surface');
      const frameChecked   = getChecked('frame');

      // Si aún no hay ambos, solo pinta lo que haya
      if (!surfaceChecked || !frameChecked) {
        const sIdx = surfaceChecked ? getIndexAmong(surfaceAll, surfaceChecked) : 1;
        const fIdx = frameChecked   ? getIndexAmong(frameAll, frameChecked)   : 1;
        setSurfaceClass(sIdx);
        setVariantClass(sIdx, fIdx);
        updateFrameLabel();
        return;
      }

      let sIdx = getIndexAmong(surfaceAll, surfaceChecked);
      let fIdx = getIndexAmong(frameAll, frameChecked);

      // Comprobación de validez basada en DOM (locale-proof)
      const frameInvalid = frameChecked.disabled || frameChecked.classList.contains('disabled');

      if (frameInvalid) {
        const enabledFrames = getEnabledInputs('frame');
        if (enabledFrames.length) {
          enabledFrames[0].click(); // actualiza estado visual
          const newFrameChecked = getChecked('frame');
          fIdx = getIndexAmong(frameAll, newFrameChecked);
        } else {
          const first = frameAll[0];
          if (first && !first.checked) first.click();
          fIdx = 1;
        }
      }

      if (slider) slider.scrollLeft = 0;

      setSurfaceClass(sIdx);
      setVariantClass(sIdx, fIdx);
      updateFrameLabel();
    }

    /* ------------------ INICIAL ------------------ */
    ensureValidOrAdjust();

    /* ------------------ EVENTOS ------------------ */
    document.addEventListener('change', (e) => {
      if (e.target.matches('input[data-type="surface"], input[data-type="frame"], select[name^="options["]')) {
        setTimeout(() => {
          ensureValidOrAdjust();
        }, 0);
      }
    });

    document.addEventListener('variant:change', () => {
      setTimeout(() => {
        ensureValidOrAdjust();
      }, 0);
    });

    // fallback por si <variant-selects> tarda en montar
    let tries = 0;
    const timer = setInterval(() => {
      if (document.querySelector('variant-selects') || tries++ > 50) {
        clearInterval(timer);
        ensureValidOrAdjust();
      }
    }, 100);
  }
})();
